import React, { ChangeEvent } from "react";
import { t } from "i18next";
import { Select } from "../../forms/components/Select";
import { canEdit } from "../utils/helpers";
import { WingmanAdminDocument } from "../models/WingmanAdminDocument";

const WingmanAdminViewableSelect = ({
  viewableFlag,
  handleViewableFlag,
  fileName,
  id,
  uploadStatus,
  brands,
  authorizedBrands,
}: {
  viewableFlag?: boolean;
  handleViewableFlag: (payload: WingmanAdminDocument) => void;
  fileName: string;
  id: number;
  uploadStatus: string;
  brands: string[];
  authorizedBrands: string[];
}) => {
  const userCanEdit = canEdit(authorizedBrands, brands);
  const disabled = uploadStatus === "Complete" && !userCanEdit;

  const handleChange = async (event: ChangeEvent<HTMLSelectElement>) => {
    const valueSelected = event.target.value === "true";
    handleViewableFlag({
      Filename: fileName,
      Viewable: valueSelected,
      id: id,
      uploadStatus: uploadStatus,
    });
  };

  return (
    <Select
      isForm={false}
      name={"Viewable Document"}
      title={t`Viewable`}
      disabled={disabled}
      className="inline-flex items-center py-1 w-13"
      innerClassName="bg-white py-1"
      onChange={handleChange}
      defaultValue={viewableFlag !== undefined ? String(viewableFlag) : ""}
    >
      {viewableFlag === undefined && (
        <option value="">{t`Select Option`}</option>
      )}
      <option value="true">True</option>
      <option value="false">False</option>
    </Select>
  );
};

export default WingmanAdminViewableSelect;

